<template>
  <v-btn class="content-menu-btn" @click.stop="toggleDrawer">
    <v-icon class="content-menu-icon" :icon="`fa-regular ${buttonIcon}`" />
    <span class="content-menu-text d-none d-md-inline">{{ buttonText }}</span>
  </v-btn>
</template>

<script lang="ts">
import { contentMenuVisible, pdfContentMenuVisible } from "~/helpers"
import { useDrawerStore } from "~/stores/drawerStore"

export default {
  setup() {
    const drawerStore = useDrawerStore()
    return { drawerStore }
  },

  computed: {
    contentMenuVisible() {
      return contentMenuVisible(this.$route)
    },

    pdfContentMenuVisible() {
      return pdfContentMenuVisible(this.$route)
    },

    buttonText() {
      if (this.contentMenuVisible) {
        return "Viedgrāmatu saturs"
      } else if (this.pdfContentMenuVisible) {
        return "Satura rādītājs"
      } else {
        return "Filtrs"
      }
    },

    buttonIcon() {
      return this.contentMenuVisible || this.pdfContentMenuVisible ? "fa-list" : "fa-filter-list"
    },
  },

  methods: {
    toggleDrawer() {
      this.drawerStore.closeDesktopDrawer()
      this.drawerStore.toggleContentMenu()
    },
  },
}
</script>

<style lang="sass">
.content-menu-btn
  min-width: 0
  text-transform: none
  font-weight: 400
  font-size: 16px
  color: #221B00
  letter-spacing: 0.1px

.content-menu-icon
  margin-right: 12px
</style>
